import { ComponentChildren, h, Fragment } from 'preact'
import { PartiResultat } from '../../../domain'
import { useCustomContext } from '../../../../lib/context'

type Props = {
  partier: PartiResultat[]
  antall: number | undefined
  children: ComponentChildren
}

export function getTotaltAntallMandater(partier: PartiResultat[]) {
  return partier
    .filter(parti => parti.parti.kategori > 0)
    .map(parti => parti.mandater)
    .reduce((total, mandater) => {
      if (mandater) {
        return total + (mandater.antall || 0)
      } else {
        return total
      }
    }, 0)
}

export function HasMandater(props: Props) {
  const { antall, partier } = props
  const { sendError } = useCustomContext()
  const totaltAntallMandater = getTotaltAntallMandater(partier)
  if (!antall) {
    return null
  }

  if (totaltAntallMandater > 0 && totaltAntallMandater !== antall) {
    sendError &&
      sendError(
        `Styret består av ${antall}, men totalt antall stemmer for partiene er ${totaltAntallMandater}`
      )
  }

  if (totaltAntallMandater === antall) {
    return <Fragment>{props.children}</Fragment>
  } else {
    return <Fragment />
  }
}
